module.exports = __webpack_public_path__ + "img/@news_list1.f138c07f.jpg";